import { useDispatch, useSelector } from "react-redux";
import { getFavouriteDetailsHandler } from "@redux/Bookmark/bookmark.action";
import { loadingBookmarkData } from "@redux/Bookmark/bookmarksSlice";
import { useEffect, useState } from "react";
import { shipmentsFilters } from "../../utils/constant";
import { SingleFilter } from "@components/templates/Filters/SingleFilters";
import { MulitpleFilter } from "@components/templates/Filters/MultipleFilters";

export const TabHeader = ({ setPayload, payload, setCurrentPage }) => {
  const state = useSelector((state) => state.bookmarkDetails.bookmarkData);
  const dispatch = useDispatch();
  const [filtersData, setFiltersData] = useState({});

  useEffect(() => {
    if (state?.filter && Object.keys(state.filter)?.length) {
      let filterObj = {};
      Object.keys(state.filter).map((item) => {
        if (state.filter[item] && state.filter[item].length) {
          filterObj[item] = state.filter[item];
        }
      });
      setFiltersData(filterObj);
    }
  }, [state?.filter]);

  const onChangeHandler = (parentFilter, filter, clearType) => {
    const payloadClone = JSON.parse(JSON.stringify(payload));
    if (clearType === "clear") {
      payloadClone.filters[parentFilter] = [];
    } else if (clearType === "clearAll") {
      payloadClone.filters = { ...shipmentsFilters };
    } else {
      let index = payloadClone.filters[parentFilter].findIndex((filterValue) => filterValue === filter);
      if (index > -1) {
        payloadClone.filters[parentFilter].splice(index, 1);
      } else {
        payloadClone.filters[parentFilter].push(filter);
      }
    }
    payloadClone.from = 0;
    setCurrentPage(1);
    dispatch(loadingBookmarkData());
    dispatch(getFavouriteDetailsHandler({ payload: payloadClone }));
    setPayload(payloadClone);
  };

  const pendoEventHandler = () => {
    return;
  };

  return (
    <div>
      <div className={`d-flex`}>
        <div>{filtersData && Object.keys(filtersData).length === 1 ? <SingleFilter pendoEventHandler={pendoEventHandler} isDisabled={state.loading} filterData={filtersData} onChangeHandler={onChangeHandler} payload={payload} /> : <MulitpleFilter pendoEventHandler={pendoEventHandler} isDisabled={state.loading} filterData={filtersData} onChangeHandler={onChangeHandler} payload={payload} />}</div>
      </div>
    </div>
  );
};
